import React from "react";

import { BrandLockup } from "../BrandLockup";
import { entregas } from "../../../utils/copy";
import manuSebo from "../../../assets/images/ConversasTerapeuticas/como-funciona.jpg";

export function ComoFunciona() {
  return (
    <section id="como-funciona" data-bg="#f0eadb" className="poster-section how-section">
      <div className="how-copy">
        <BrandLockup inline />
        {/* "cada ciclo" e a linha "a cada mês você terá" voltaram do build que
            a Manuela usa como referência: sem eles a lista aparecia sem dizer
            que é o conteúdo de UM MÊS dentro do ciclo. */}
        <h2 data-motion="title" className="how-title">
          <span className="type-display">Como funciona</span>
          <em className="type-voice">cada ciclo</em>
        </h2>
        <p className="type-voice how-lead">a cada mês você terá</p>
        <ol data-motion-list className="how-list">
          {entregas.map((entrega) => (
            <li key={entrega.titulo} className={entrega.titulo === "Encontros ao vivo" ? "is-featured" : undefined}>
              {/* "4" é informação (quanto vem por mês); "+" e "( )" são
                  marcadores tipográficos e viram ruído lido em voz alta */}
              <span
                aria-hidden={!/^\d+$/.test(entrega.marcador)}
                className={`type-display how-number${entrega.marcador.includes("(") ? " is-paren" : ""}`}
              >
                {entrega.marcador}
              </span>
              <div>
                <h3 className="type-display">{entrega.titulo}</h3>
                {/* nada de texto hardcoded aqui: o item dos encontros tinha uma
                    versão encurtada ("toda semana… falar e ser ouvida") que
                    engolia o dia da semana e o aviso de gravação. copy.ts manda. */}
                <p className="type-voice">{entrega.texto}</p>
              </div>
              {/* o floreio manuscrito "com a Manu" existia porque a versão curta
                  não dizia quem conduzia. Com o texto de copy.ts a frase já traz
                  "com a Manu", e o floreio virava eco a 15 palavras de distância. */}
            </li>
          ))}
        </ol>
      </div>

      <figure data-motion="media" className="how-photo">
        <img
          src={manuSebo}
          alt="Manuela Xavier debruçada sobre um livro aberto em meio a pilhas de livros num sebo"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </figure>
    </section>
  );
}
